import PermissionRepository from "../repository/permission-repository";
import SectionService from "./section-service";

class PermissionService
{
    #permissionRepository;
    #sectionService;

    constructor() {
        this.#permissionRepository = new PermissionRepository();
        this.#sectionService = new SectionService();
    }

    async findAllByRoleId(roleId) {
        try {
            const data = await this.#permissionRepository.getAllByRoleId(roleId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findAllByUserId(userId) {
        try {
            const data = await this.#permissionRepository.getAllByUserId(userId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async findAllForCurrentUser() {
        try {
            const permissionList = await this.#permissionRepository.getAllByCurrentUser();
            const sectionList = await this.#sectionService.findAll();
            const sections = {};

            sectionList.forEach((item) => {
                sections[item.id] = item;
            });

            const permissions = permissionList.map((item) => {
                return {
                    ...item, 
                    section: sections[item.section_id].name
                };
            });

            return permissions;
        } catch (error) {
            console.error(error);
        }
    }

    async syncPermissionsByRoleId(permissions, roleId) {
        try {
            const data = await this.#permissionRepository.syncByRoleId(permissions, roleId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async syncPermissionsByUserId(permissions, userId) {
        try {
            const data = await this.#permissionRepository.syncByUserId(permissions, userId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default PermissionService;